import _ from 'classnames';
import React, { useCallback } from 'react';
import { hasOwnProperty } from "../../functions/hasOwnProperty.js";
import { DataGridCell } from "../DataGridCell/DataGridCell.js";
import styles from "./DataGridRow.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export const DataGridRow = /*#__PURE__*/React.memo(({
  rowData,
  rowDecorator,
  columnCount,
  hydratedColumns,
  isLast,
  onRowClick,
  onRightClick,
  hasBody,
  rowAlternating,
  hasSeparator,
  hasSeparatorNext,
  isLastColumnFixed,
  isOverflowing,
  fullyScrolledLeft,
  index
}) => {
  const alternateClass = columnCount % 2 === 1 ? styles.rowAlternatingEven : styles.rowAlternatingOdd;
  const handleClick = useCallback(() => {
    if (hasBody) {
      if (hasBody(rowData, rowData._id)) {
        onRowClick(rowData._id);
      }
    } else {
      onRowClick(rowData._id);
    }
  }, [hasBody, onRowClick, rowData]);
  const onContextMenuClick = useCallback(e => {
    if (onRightClick) {
      e.preventDefault();
      onRightClick(rowData._id);
    }
  }, [onRightClick, rowData._id]);
  const cells = [];
  let stepOver = 0;
  for (let i = 0; i < columnCount; i++) {
    if (stepOver > 0) {
      stepOver--;
      continue;
    }
    let rowItem;
    const {
      cellRenderer,
      name,
      align
    } = hydratedColumns[i];
    if (typeof cellRenderer === 'function') {
      rowItem = cellRenderer(rowData, rowData._id, index);
    } else {
      if (!hasOwnProperty(rowData, name)) {
        throw new Error(`Expected data to have property '${name}'. Please use a custom cellRenderer for column '${name}' instead.`);
      }
      rowItem = {
        content: rowData[name]
      };
    }
    const isLastColumn = i === columnCount - 1;
    const isLastButOneColumn = i === columnCount - 2;
    const isSticky = isLastColumnFixed && isLastColumn || isLastColumnFixed && isLastButOneColumn && !!hasBody;
    cells.push(/*#__PURE__*/_jsx(DataGridCell, {
      align: align,
      span: rowItem.span,
      isVisible: rowItem.isVisible,
      isFirst: i === 0,
      isLast: isLastColumn,
      isLastRow: isLast,
      onClick: handleClick,
      isSticky: isSticky,
      hasBody: !!hasBody,
      isLastButOne: isLastButOneColumn,
      isOverflowing: isOverflowing,
      fullyScrolledLeft: fullyScrolledLeft,
      children: rowItem.content
    }, `${rowData._id}-${i}`));
    stepOver = (rowItem.span ?? 0) - 1;
  }
  return rowDecorator(/*#__PURE__*/_jsx("div", {
    className: _(rowAlternating && alternateClass, styles.dataGridRow, hasSeparator && styles.separator, hasSeparatorNext && styles.nextSeparator),
    onContextMenu: onContextMenuClick,
    children: cells
  }), rowData);
});